module.exports = __webpack_public_path__ + "img/5c33cd8.png";